import { Model } from "vuex-fetch-factory";

export interface FileEntryRaw {
  source: string;
  relation_id: number;
  project: string;
  archive_id: number;
  description: string;
  category: string;
  archive_date: string;
  extension: string;
}

export class FileEntryModel implements Model<FileEntryModel, FileEntryRaw> {
  public source = "";
  public relation_id = 0;
  public project = "";
  public archive_id = 0;
  public description = "";
  public category = "";
  public archive_date = "";
  public extension = "";

  public getNew(): FileEntryModel {
    return new FileEntryModel();
  }

  public fillModel(raw: FileEntryRaw): this {
    this.source = raw.source;
    this.relation_id = raw.relation_id;
    this.project = raw.project;
    this.archive_id = raw.archive_id;
    this.description = raw.description;
    this.category = raw.category;
    this.archive_date = raw.archive_date;
    this.extension = raw.extension;

    return this;
  }

  public getRaw(): FileEntryRaw {
    return {
      source: this.source,
      relation_id: this.relation_id,
      project: this.project,
      archive_id: this.archive_id,
      description: this.description,
      category: this.category,
      archive_date: this.archive_date,
      extension: this.extension,
    };
  }

  public get link(): string {
    const l = `api/relationprofile/me/archive/${
      this.archive_id
    }/download/${encodeURI(this.description)}`;

    if (l.endsWith("." + this.extension)) return l;
    return l + "." + this.extension;
  }
}
